module.exports = __webpack_public_path__ + "img/7_171.76e2e612.png";